import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

interface LegalPageProps {
  title: string;
  subtitle?: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalPage: React.FC<LegalPageProps> = ({ title, subtitle, lastUpdated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-inner">
          <button className="legal-back-btn" onClick={() => navigate(-1)} type="button">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back
          </button>
          <div
            className="legal-logo"
            onClick={() => navigate('/')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') navigate('/');
            }}
          >
            <img
              src="/genlend-logo.png"
              alt="GenLend"
              className="legal-logo-icon"
              style={{ width: '52px', height: '52px', borderRadius: '50%' }}
            />
            <span className="legal-logo-text">GenLend</span>
          </div>
        </div>
      </header>

      <section className="legal-hero">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        <p className="legal-updated">Last updated: <strong>{lastUpdated}</strong></p>
      </section>

      <section className="legal-content">
        <div className="legal-draft-banner" role="status">
          <strong>Draft content.</strong> This page contains placeholder wording while our legal team finalises the official text. If you need legal information urgently, please contact us using the details at the bottom of this page.
        </div>
        {children}
      </section>

      <footer className="legal-footer">
        <p>
          © {new Date().getFullYear()} GenLend. All rights reserved.
        </p>
        <p>
          <a href="/terms">Terms &amp; Conditions</a> · <a href="/privacy">Privacy Policy</a> · <a href="/faq">FAQ</a>
        </p>
      </footer>
    </div>
  );
};

export default LegalPage;
